export default __webpack_public_path__ + "static/media/single-project-page-05-img-03.7ae7db16.jpg";